/**
 * Na barra das 48 h (desktop): entra no modo "Próximos dias", como a aba da
 * direita (sem abrir os ajustes). Some quando a barra fica estreita (a aba continua) e quando
 * não há rodada de previsão no servidor.
 */
import { CalendarDays } from 'lucide-react';
import { useExportLock } from '../loop/playback';
import { entrarNaPrevisao } from './EntradaDaPrevisao';
import { usePrevisaoStore } from './store';

export function BotaoProximosDias() {
  const disponivel = usePrevisaoStore((s) => !!s.indice && Object.values(s.indice.modelos).some((m) => m && m.rodadas.length > 0));
  const travado = useExportLock();
  if (!disponivel) return null;
  return (
    <button
      type="button"
      onClick={entrarNaPrevisao}
      disabled={travado}
      title={travado ? 'Indisponível durante a exportação' : 'Previsão do ECMWF e do CAMS para os próximos dias'}
      className="inline-flex min-h-9 shrink-0 items-center gap-1 rounded-lg border border-ink-600 bg-ink-800 px-2 text-xs text-ink-100 hover:bg-ink-700 focus-visible:outline-2 focus-visible:outline-violet-400 disabled:opacity-40 @max-[900px]:hidden"
    >
      <CalendarDays className="size-3.5 text-violet-300" aria-hidden />
      Próximos dias ▸
    </button>
  );
}
